import {
	API_GET_ALL_INSURANCE,
	API_ADMIN_GET_ALL_INSURANCE,
	API_ADMIN_GET_INSURANCE,
	ADMIN_INIT_NEW_INSURANCE,
	ADMIN_RESET_FOCUS_INSURANCE,
	API_ADMIN_POST_INSURANCE,
	API_ADMIN_PATCH_INSURANCE,
	API_ADMIN_DELETE_INSURANCE,
	API_SEARCH_INSURANCE,
} from "actions/insurance";

export function getAllInsurances() {
	return {
		type: API_GET_ALL_INSURANCE,
		payload: {
			request: {
				url: `/insurances`,
			},
		},
	};
}

export function adminGetAllInsurances() {
	return {
		type: API_ADMIN_GET_ALL_INSURANCE,
		payload: {
			request: {
				url: `/admin/insurances`,
			},
		},
	};
}

export function searchInsurances(searchData, size, start) {
	return {
		type: API_SEARCH_INSURANCE,
		payload: {
			request: {
				url: `/insurances/search/${size}/${start}`,
				method: "GET",
				params: searchData,
			},
		},
	};
}

export function adminGetInsurance(insurance) {
	return {
		type: API_ADMIN_GET_INSURANCE,
		payload: {
			request: {
				url: `/admin/insurances/${insurance.id}`,
			},
		},
	};
}

export function adminPostInsurance(insurance) {
	return {
		type: API_ADMIN_POST_INSURANCE,
		payload: {
			request: {
				url: `/admin/insurances`,
				method: "POST",
				data: insurance,
			},
		},
	};
}

export function adminPatchInsurance(insurance) {
	return {
		type: API_ADMIN_PATCH_INSURANCE,
		payload: {
			request: {
				url: `/admin/insurances/${insurance.id}`,
				method: "PATCH",
				data: insurance,
			},
		},
	};
}

export function adminDeleteInsurance(insurance) {
	return {
		type: API_ADMIN_DELETE_INSURANCE,
		payload: {
			request: {
				url: `/admin/insurances/${insurance.id}`,
				method: "DELETE",
			},
		},
	};
}

export function initNewInsurance() {
	return {
		type: ADMIN_INIT_NEW_INSURANCE,
	};
}

export function resetFocusInsurance() {
	return {
		type: ADMIN_RESET_FOCUS_INSURANCE,
	};
}
